let firstEntryTime = 0
let segmentStartTime = 0
let timer: number | null = null
let staySeconds = 0

const today = new Date().toISOString().split('T')[0]
const FIRST_ENTRY_KEY = `firstEntryTime_${today}`
const ACCUMULATED_KEY = `accumulatedStay_${today}`

const triggerKey = (k: string) => `${k}_${today}`

function loadState() {
  const stored = localStorage.getItem(FIRST_ENTRY_KEY)
  if (stored) {
    firstEntryTime = parseInt(stored, 10)
  } else {
    firstEntryTime = Date.now()
    localStorage.setItem(FIRST_ENTRY_KEY, String(firstEntryTime))
  }

  const acc = localStorage.getItem(ACCUMULATED_KEY)
  staySeconds = acc ? parseInt(acc, 10) : 0
}

function saveAccumulated() {
  localStorage.setItem(ACCUMULATED_KEY, String(staySeconds))
}

function getSeconds() {
  if (segmentStartTime > 0) {
    return staySeconds + Math.floor((Date.now() - segmentStartTime) / 1000)
  }
  return staySeconds
}

function trigger(k: string, label: string) {
  if (localStorage.getItem(triggerKey(k)) === '1') return
  localStorage.setItem(triggerKey(k), '1')
  console.log('触发:', label)
}

function check() {
  const t = getSeconds()

  if (t >= 180) trigger('stay_3', '3min')
  if (t >= 600) trigger('stay_10', '10min')
  if (t >= 1800) trigger('stay_30', '30min')
}

function start() {
  if (segmentStartTime === 0) {
    segmentStartTime = Date.now()
  }

  if (timer) return
  timer = window.setInterval(check, 1000)
}

function stop() {
  if (segmentStartTime > 0) {
    staySeconds += Math.floor((Date.now() - segmentStartTime) / 1000)
    segmentStartTime = 0
    saveAccumulated()
  }

  if (timer) {
    clearInterval(timer)
    timer = null
  }
}

function handleVisibility() {
  if (document.hidden) {
    stop()
  } else {
    start()
  }
}

/**
 * 初始化一次（全局只调用一次）
 */
export function initStayTracker() {
  loadState()
  start()

  document.addEventListener(
    'visibilitychange',
    handleVisibility
  )

  window.addEventListener('pagehide', stop)
  window.addEventListener('beforeunload', stop)
}

/**
 * 获取当天累计停留时间（秒）
 * 当前 segment 进行中时，自动算上 now - segmentStart 的差值
 */
export function getStaySeconds() {
  return getSeconds()
}

/**
 * 获取当天第一次进入项目的时间戳
 */
export function getFirstEntryTime() {
  return firstEntryTime
}